export enum MatchCommentSource {
  CallAi = 'call_ai',
  EmailAi = 'email_ai',
  Manual = 'manual',
  AgcChat = 'agc_chat',
}
